





























import {
  Component, Vue, Provide, Prop,
} from 'vue-property-decorator';
import {
  Button, Table, TableColumn, Scrollbar, Loading, Message, DatePicker, Progress,
} from 'element-ui';
import Study from '@/servers/modules/decisive/study'; // server
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import fa from 'element-ui/src/locale/lang/fa';

    @Component({
      components: {
        Table,
        TableColumn,
        Progress,
        Button,
      },
    })
export default class extends Vue {
        private percentage:any = 0;

        private pageNum: number = 1;

        private tableData:any = [];

        private data:any = {};

        private loading = false;

        private nodeType:string = '';

        private async init(nodeId:string = '', orderField:string = '', nodeType: string) {
          this.nodeType = nodeType;
          this.loading = true;
          const form:any = {
            processInstanceId: window.LS.get('jse_data').processInstanceId,
            nodeId: nodeId || window.LS.get('jse_data').nodeGroupId,
            orderField: orderField || this.$route.query.mastery || 0,
            nodeType,
          };
          const res = await Study.studyRecordList(form).catch((e:any) => {
            console.log(e);
          });
          console.log(res);
          this.loading = false;
          if (!res.data.code) {
            this.data = res.data.data;
            for (let i = 0; i < res.data.data.length; i++) {
              const time = new Date(res.data.data[i].time);
              res.data.data[i].datetime = `${time.getFullYear()}-${Number(time.getMonth()) + 1}-${time.getDate()}`;
            }
            this.tableData = res.data.data;
          }
        }

        private mounted() {
          // 让父组件 更新子组件
          // this.$parent.change();
        }

        private tableHeaderClassName() {
          return 'table-header';
        }

        private tableRowClassName() {
          return 'table-row';
        }

        private headFirst({
          row, colunm, rowIndex, columnIndex,
        }) {
          if (rowIndex === 1) {
            // 将第二列的表头隐藏，就形成了合并表头的效果
            return { display: 'none' };
          }
        }

        // 判断当条数据处于什么状态
        private processing(data:any) {
          if (data.status == 0) {
            return 'not-learned';
          }
          if (data.status == 1) {
            return 'learning';
          }
          return 'pass';
        }

        // 查看解析
        private showDetail(data:any) {
          console.log(data, this.nodeType);
          this.$router.push({
            path: '/decisive/reStartLearningTest',
            query: {
              historyId: data.historyId,
              nodeType: this.nodeType,
            },
          });
        }
}
